const Quartier = () => {
    return (
        <div className="Quartier">Gestions quartier</div>
        
    );
}

export default Quartier;